import { rd } from '@passionware/monads';
import type { Resource } from '__types__';
import { useTranslation } from 'react-i18next';
import { WithServices } from 'v5/platform/ts/services';
import { WithToastService } from 'v5/services/front/ToastService/ToastService';
import { NotesPanel } from 'v5/patterns/widgets/attachments/NotesPanel';
import {
  useResourceAssociationActions,
  useResourceAssociations
} from './useResourceAssociations';

export interface ResourceNotesPanelProps
  extends WithServices<[WithToastService]> {
  resource: Pick<Resource, 'id' | 'first_name'>;
  disabled: boolean;
}

export function ResourceNotesPanel({
  services,
  resource,
  disabled
}: ResourceNotesPanelProps) {
  const { t } = useTranslation('resources');
  const actions = useResourceAssociationActions(resource.id);
  const associations = useResourceAssociations(resource.id);

  return (
    <NotesPanel
      services={services}
      notes={rd.map(associations, ({ notes = [] }) => notes)}
      onCreate={actions.createNote}
      onDelete={actions.deleteNote}
      disabled={disabled}
      copy={{
        title: t('ResourceNotesPanel.title'),
        fieldLabel: t('ResourceNotesPanel.fieldLabel'),
        placeholder: t('ResourceNotesPanel.placeholder'),
        submit: t('ResourceNotesPanel.submit'),
        emptyTitle: t('ResourceNotesPanel.emptyTitle'),
        emptyDescription: t('ResourceNotesPanel.emptyDescription', {
          name: resource.first_name || t('ResourceNotesPanel.fallbackName')
        }),
        loadError: t('ResourceNotesPanel.loadError'),
        unknownUser: t('ResourceNotesPanel.unknownUser'),
        deleteAria: t('ResourceNotesPanel.deleteAria'),
        createdToast: t('ResourceNotesPanel.createdToast'),
        createErrorToast: t('ResourceNotesPanel.createErrorToast'),
        deletedToast: t('ResourceNotesPanel.deletedToast'),
        deleteErrorToast: t('ResourceNotesPanel.deleteErrorToast')
      }}
    />
  );
}
